import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Style from './DropdownIcon.module.scss';

/**
 * DropdownIcon Component
 *
 * @param {Boolean} opened     - is the dropdown open?
 * @param {Function} onClick   - action to occur on click
 * @returns {Component}        - React Component
 */
const DropdownIcon = ({ opened, onClick, disabled }) => {
  const iconStatusClass = opened ? Style.iconUp : Style.iconDown;
  const classes = [Style.icon, iconStatusClass];

  if (disabled) classes.push(Style.iconDisabled);

  return (
    <span data-testid="dropdown icon toggle" className={classNames(classes)} onClick={onClick} />
  );
};

DropdownIcon.propTypes = {
  opened: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};
DropdownIcon.defaultProps = {
  opened: null,
  onClick: () => {},
  disabled: null,
};

export default DropdownIcon;
